import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import SprawdzCennikiPojedyncze from "./SprawdzCennikiPojedyncze";

export default class SprawdzKonfiguraceCennikiTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderInfo(cell, row) {
        let array = cell.split(';')
        let cenniki = []

        for (let i = 0; i < array.length; i++) {

            let item = array[i]

            item = item.replace('id_tr', '"id_tr"')
            item = item.replace('data', '"data"')
            item = item.replace('rodz', '"rodz"')
            item = item.replace('status', '"status"')
            item = item.replace('odcinki', '"odcinki"')
            item = '"naz_tr":"'+row.naz_tr+'",'+item

            cenniki.push(JSON.parse('{' + item + '}'))
        }


        return (
            <SprawdzCennikiPojedyncze cenniki={cenniki} />
        )
    }

    renderTrasa(cell,row){
        return(<div style={{fontSize:'20px', padding:'5px'}}>
            <span className={'label label-ebus-primary'} style={{fontSize:'inherit'}}>{cell}</span>
        </div>)
    }

    render() {

        return (
            <div>
                <h2 style={{textAlign: 'center', margin: '30px 0'}}>
                    Konfiguracja cenników na wszystkich trasach
                </h2>
                <div>
                    <BootstrapTable data={this.props.data}
                                    hover
                    >
                        <TableHeaderColumn dataField='id_tr' isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='naz_tr'
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.renderTrasa}
                        >Trasa</TableHeaderColumn>
                        <TableHeaderColumn dataField='info'
                                           thStyle={tabgrid.tg10} tdStyle={tabgrid.tg10} dataSort
                                           dataFormat={this.renderInfo}
                        >Czy cennik jest uzupełniony?</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/sprawdzKonfiguracje/components/componentsCenniki/SprawdzKonfiguraceCennikiTable.js